// react-dropzone calls onDrop even when every file was rejected (wrong type, too large),
// handing over an empty acceptedFiles. Drop handlers across the app read acceptedFiles[0]
// and pass it straight to URL.createObjectURL, which throws on undefined — stranding any
// loading state the handler had already set. Rejected files are surfaced separately by
// <RejectionFiles />, so an all-rejected drop has nothing for the consumer to do.
export const skipEmptyDrop = (onDrop) => (acceptedFiles, fileRejections, event) => {
  if (!acceptedFiles?.length) {
    return;
  }
  onDrop?.(acceptedFiles, fileRejections, event);
};
